import getActionsByDocument from '../../../../components/comments/actions';

const DOCUMENT = 'APPLICANT_COMMENTS_';

export default getActionsByDocument(DOCUMENT);
